import { useLocation } from "react-router-dom";
import { Folder, FolderOutlined, Home, HomeOutlined, Search, SearchOutlined } from "@mui/icons-material";

import analytics from "fond/analytics";
import { IconLink } from "fond/widgets/IconBar";

export const HomeIconBarContent: React.FC = () => {
  const location = useLocation();
  const isProjectsActive = () => {
    const path = location.pathname;
    return path !== "/" && !path.startsWith("/settings") && !path.startsWith("/admin") && !path.startsWith("/search");
  };

  return (
    <>
      <IconLink data-testid="side-home-button" Icon={HomeOutlined} ActiveIcon={Home} to="/" onClick={() => analytics.track("iconbar.home.clicked")}>
        Home
      </IconLink>
      <IconLink
        data-testid="side-projects-button"
        Icon={FolderOutlined}
        ActiveIcon={Folder}
        to="/workspace"
        isActive={isProjectsActive}
        onClick={() => analytics.track("iconbar.projects.clicked")}
      >
        Projects
      </IconLink>
      <IconLink
        data-testid="side-search-button"
        Icon={SearchOutlined}
        ActiveIcon={Search}
        to="/search"
        onClick={() => analytics.track("iconbar.search.clicked")}
      >
        Search
      </IconLink>
    </>
  );
};
